import t from "react";
class s extends t.Component {
  constructor(r) {
    super(r), this.state = {
      hasError: !1,
      errorTitle: r.errorTitle ? r.errorTitle : "We're sorry, but something went wrong.",
      errorMessage: r.errorMessage ? r.errorMessage : 'Please try again later. If the problem persists please contact us at <a href="#contact-us">our support page</a>.'
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(r, e) {
    console.error("Caught error: ", r), console.error("Error info: ", e);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
export {
  s as BlankErrorBoundary,
  s as default
};
